module.exports = __webpack_public_path__ + "DISCOVER_IllustrationUpdate.svg";